import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listSteps} from '../utils/utilsProcess';

import * as PD from '../classes/pdStyle';

class ListSteps extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Steps: [],
            errorMessage: ''
        };

        this.dsd = new dsd();
    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){
   if (!isEqual(this.props, prevProps)){
       this.setup();
   }
}

loadData(filters){

    const onLoad = function(arr){
        this.setState({ Steps: arr, renderState: 'loaded' });
        if (this.state.onLoad){ this.state.onLoad(arr.length); }
    }.bind(this);

    const onError = function(e){
        this.setState({ renderState: 'failed', errorMessage: e.message });
    }.bind(this);

    listSteps(this.dsd, filters, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:false,
            process: false
        },
        onLoad: null
    }

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);
    this.loadData(StateChange.filters);
        
}



    included(Step) {

        let IncludeThis = true;

        if (!Step){
            IncludeThis = false;
        }

        return IncludeThis;
    }

    render() {

        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }

        if (this.state.renderState === 'loaded') {
            let arrSteps = this.state.Steps;
            if (isArray(arrSteps)){
                if (arrSteps.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Type</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.process &&
                                        <PD.Th>Process</PD.Th>                            
                                    }

                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrSteps.map(
                                    (Step, pos) => 
                                    {
                                        if (this.included(Step)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/step/" + Step._id} > {Step.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        <PD.Tr>
                                                            {Step.type &&
                                                                Step.type
                                                            }
                                                        </PD.Tr>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Step.Process){
                                                                        if (Step.Process.Owner){
                                                                            return Step.Process.Owner.organisation;
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.process &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Step.Process){
                                                                        return Step.Process.name;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Step.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListSteps_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListSteps {...props} navigation={navigation} location={location} params={params} />;
  }
